import { render, staticRenderFns } from "./DiscountConfirm.vue?vue&type=template&id=6aa2e3e0"
import script from "./DiscountConfirm.vue?vue&type=script&lang=js"
export * from "./DiscountConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports